import { useContext, ReactElement, useMemo, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { LiveContext } from "../../Context/context.ts";
import releaseDates from "../../utils/releaseDates";
import { isPastDate } from "../../utils/isPastdate.ts";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const PublicationsDatesTableTemplate = ({
  collection,
  library,
}): ReactElement => {

  const { api_country_code } = useContext(LiveContext) as LiveContextType & {
    api_country_code: string;
  };

  const _collection = useMemo(() => {
    if (Array.isArray(collection)) {
      return collection;
    }
    return [];
  }, [collection]);

    useEffect(() => {
        if (!_collection.length) return;

        const scheduleEl = document.getElementsByClassName("schedule")[0];
        if (!scheduleEl) return;

        const modalBody = scheduleEl.closest(".modal-body");
        if (!modalBody) return;

        setTimeout(() => {
            //modalBody.scrollTop = modalBody.scrollHeight;

            modalBody.scrollTo({
              top: modalBody.scrollHeight,
              behavior: "smooth", // плавная прокрутка
            });
            
        }, 500);
    }, [_collection]);

  const datesTable = collection.map(
    (
      elm: {
        issueNumber: number;
        date: string;
        date2: string;
        boxNumber: number;
      },
      index: React.Key
    ) => {
      const _date =
        elm?.date ||
        releaseDates({
          number: elm.issueNumber,
          langCode: api_country_code,
          startDate:
            api_country_code !== "HU"
              ? new Date(2024, 11, 17)
              : new Date(2025, 1, 3),
        });

      const _date2 =
        elm?.date2 ||
        releaseDates({
          number: elm.issueNumber,
          langCode: api_country_code,
          startDate:
            api_country_code !== "HU"
              ? new Date(2025, 0, 30)
              : new Date(2025, 2, 20),
        });

      const isPast = _date !== null && isPastDate(_date);
      const isPast2 = _date2 !== null && isPastDate(_date2);

      const cellStyle = isPast ? { background: "#e3fcef" } : undefined;
      const cellStyle2 = isPast2
        ? { background: "rgba(0, 151, 225, 0.25)" }
        : undefined;

      return (
        <tr key={index}>
          <td width={"100"} style={cellStyle}>
            <div style={{ display: "flex", alignItems: "center" }}>
              {elm.issueNumber}
              {isPast && (
                <IoMdCheckmarkCircleOutline
                  style={{
                    fontSize: "1.25rem",
                    color: "green",
                    marginLeft: "auto",
                  }}
                />
              )}
              {isPast2 && (
                <IoMdCheckmarkCircleOutline
                  style={{
                    fontSize: "1.25rem",
                    color: "rgb(0, 151, 225)",
                    marginLeft: 2,
                  }}
                />
              )}
            </div>
          </td>
          <td style={cellStyle}>{_date}</td>
          {!!library[7] && <td style={cellStyle2}>{_date2}</td>}
          {/* <td>{elm.boxNumber}</td> */}
        </tr>
      );
    }
  );

  return (
    <div id="publications-dates-table-template" className="schedule">
      <div className="modal-body-inner">
        <Row>
          <Col xs={12}>
            <Table striped bordered>
              <thead style={{ lineHeight: "1.2em" }}>
                <tr>
                  <th style={{ verticalAlign: "middle" }}>{library[0]}</th>
                  <th style={{ verticalAlign: "middle" }}>{library[6]}</th>

                  {!!library[7] && (
                    <th>
                      {library[6]} <span className="h5 text-info">*</span>
                      <br />
                      <span
                        style={{
                          fontSize: 14,
                          fontWeight: 400,
                          lineHeight: "1em",
                        }}
                      >
                        {`(${library[7]})`}
                      </span>
                    </th>
                  )}

                  {/* <th>{library[3]}</th> */}
                </tr>
              </thead>
              <tbody>{datesTable}</tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PublicationsDatesTableTemplate;
